(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_fitment-specs-table"] && !Shopify.designMode) return;
  try {
    (function () {
    var selector = '[data-pdp-fitment]';
    var debounceTimer;

    function debounce(callback) {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(callback, 100);
    }

    function replaceFitmentFromDocument(doc) {
      var nextFitment = doc.querySelector(selector);
      var currentFitment = document.querySelector(selector);

      if (currentFitment && nextFitment) {
        currentFitment.replaceWith(nextFitment);
      }
    }

    function updateFitmentFromVariantId(variantId) {
      var currentFitment = document.querySelector(selector);
      if (!currentFitment || !variantId) return;

      var sectionId = currentFitment.dataset.sectionId;
      if (!sectionId) return;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', sectionId);

      fetch(url.toString())
        .then(function (response) {
          if (!response.ok) return '';
          return response.text();
        })
        .then(function (html) {
          if (!html) return;
          replaceFitmentFromDocument(new DOMParser().parseFromString(html, 'text/html'));
        })
        .catch(function () {});
    }

    document.addEventListener('variant:update', function (event) {
      var detail = event.detail || {};
      var variant = detail.resource || detail.variant;

      if (detail.data && detail.data.html) {
        replaceFitmentFromDocument(detail.data.html);
        return;
      }

      debounce(function () {
        updateFitmentFromVariantId(variant && variant.id);
      });
    });

    document.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;

      debounce(function () {
        updateFitmentFromVariantId(variant && variant.id);
      });
    });

    document.addEventListener('change', function (event) {
      if (!event.target || event.target.name !== 'id') return;

      debounce(function () {
        updateFitmentFromVariantId(event.target.value);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
